import React from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import { AiOutlineWarning } from "react-icons/ai";

function Notification() {
	return (
		<Layout>
			<Container>
				<div className="grid col-span-12">
					<div className="flex items-center justify-center">
						<AiOutlineWarning className="text-yellow-500 text-xl" />
						<p className="text-lg pl-2">Warning</p>
					</div>
					<p className="max-w-[20rem] text-center text-sm mt-2 mb-5 px-2">
						Notifications are denied on this device. Please allow notifications manually in the
						browser settings.
					</p>
				</div>
			</Container>
		</Layout>
	);
}

export default Notification;
